import Swal, { runWithProgress, Toast } from '../../App/components/Alert';
import { authProvider } from '../../common/auth';
import log from '../../common/logging';
import i18n from '../../locales/i18n';
import { HousekeepingReportQuery } from '../../store/models/domain';
import { getFacility } from '../../store/reducers/domain/facilities';
import { loadAuditMarkingReports, loadHousekeepingReports } from '../../store/reducers/domain/housekeeping';
import store from '../../store/store';

abstract class HousekeepingService {

  public static getUpdates(facilityId: string, reportId?: string, roomId?: string) {

    // just adding a guard that the user is still within the same facility
    if (facilityId !== authProvider.getAccountInfo()?.facility?.id) return;

    // Update only the ff requirements:
    // Update if there is no roomId or no filteredRoomIds-- applies to the entire building/all rooms
    // Update reportID and roomId exists in filteredRoomIds
    // Otherwise, don't update
    const state = store.getState();
    const filteredRoomIds = state.facilities.filteredRoomIds;
    const hasNoRoomFilter = !roomId || filteredRoomIds.length === 0;
    const isFilteredRoomReport = !!reportId && filteredRoomIds.includes(roomId);
    const shouldUpdate = hasNoRoomFilter || isFilteredRoomReport;

    if (facilityId && shouldUpdate) {
      log.info('Facility Housekeeping report requires update', facilityId);

      let payload: HousekeepingReportQuery = { LatestRoomHistory: true }
      if (reportId) payload = { ReportId: reportId }
      else if (!reportId && filteredRoomIds.length > 0) payload = { roomIds: filteredRoomIds, facilityId, LatestRoomHistory: true }

      if (!roomId) {
          runWithProgress(i18n.t("Getting updates..."), () => this.loadUpdates(facilityId, payload,true), { toast: true, position: 'top-end' })
      } else {
          this.loadUpdates(facilityId, payload, false)
      }
    }
  }

  private static async loadUpdates(facilityId: string, payload: HousekeepingReportQuery, showProgress: boolean) {
    Promise.all([
      store.dispatch(loadHousekeepingReports(payload)),
      store.dispatch(getFacility(facilityId)),
      store.dispatch(loadAuditMarkingReports({ latestRoomHistory: true })),
    ])
    .then(([housekeeping, facility]) => {
        if (!loadHousekeepingReports.fulfilled.match(housekeeping)) {
            throw housekeeping.error
        }
        if (!getFacility.fulfilled.match(facility)) {
            throw facility.error
        }
        if (showProgress) Swal.close()
    })
    .catch((error: any) => {
        Toast.fire({
            icon: 'error',
            title: 'Unable to reconnect. Please check your internet.',
        })
    })
    }

}

export default HousekeepingService;
